'use client'
import styled from "styled-components";
import {hover} from "@/styles/globalStyleVars";
import {Col, Container, Row} from "react-bootstrap";
import {Img} from "@/components/Img";
import Link from "next/link";
import Button from "@/components/Button";
import reactHtmlParser from "react-html-parser";
import {useState} from "react";




const MyComponent = ({data}) => {
    const firstnews = data?.[0];
    const allnews = data?.slice(1);

    const initialDisplayCount = 4;

    // State to manage the number of items to display
    const [displayCount, setDisplayCount] = useState(initialDisplayCount);

    // Handler for "Load More" button click
    const handleLoadMore = () => {
        // Increase the number of items to display
        setDisplayCount(displayCount + initialDisplayCount);
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
    }

    return (
        <StyledComponent className={"news-list pt-100 pb-100"} >
            <Container>
                <Row>
                    <Col md={12}>
                        <div className="news-list-first">
                            <Link href={`/newsroom/${firstnews?.data?.slug}`}/>
                            <div className="news-list-first__left">
                                <p>{formatDate(firstnews?.data?.date)}</p>
                                <h5>{reactHtmlParser(firstnews?.data?.subtitle)}</h5>
                            </div>
                            <div className="news-list-first__right">
                                <div className="img-wrapper">
                                    <img className={'thumb'} src={firstnews?.images?.list?.find(element => element?.thumb === 'on')?.cdn_path} alt={'home-cta'}/>
                                    <img className={'arrow'} src="/images/static/white-arrow.svg" alt=""/>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {
                        allnews &&
                        Array.isArray(allnews) &&
                        allnews.slice(0, displayCount)?.map((item, index) => {
                            return(
                                <Col md={6} key={index}>
                                    <div className="news-list-item">
                                        <Link href={`/newsroom/${item?.data?.slug}`}/>
                                        <div className="news-list-item__img">
                                            <img src={item?.images?.list?.find(element => element?.thumb === 'on')?.cdn_path} alt={'home-cta'}/>
                                        </div>
                                        <div className="news-list-item__content">
                                            <div className="news-list-item__content__top">
                                                <p>{formatDate(item?.data?.date)}</p>
                                                <img src="/images/static/arrow-news.svg" alt=""/>
                                            </div>
                                            <h6>{reactHtmlParser(item?.data?.subtitle)}</h6>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }



                </Row>
                {allnews && allnews.length > displayCount && (
                <Row className={'load-more'}>
                    <Col>
                            <div className={'lower_button '} onClick={handleLoadMore}>
                                <Button src text={'Load More'} border={'1px solid #638297'} background={'transparent'}
                                        hoverBackground={'#978C21'} hovercolor={'#FFF'} color={'#638297'} arrowfilter={'brightness(0%)'}/>
                            </div>

                    </Col>
                </Row>
                )}
            </Container>
        </StyledComponent>
    );

};

const StyledComponent = styled.section`
    background-color: #ffffff;
    .news-list-item{
        background-color: #f9f9f9;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        border-radius: 5px;
        a{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
        &__img{
            flex:0 0 30%;
            img{
                width: 200px;
                height: 200px;
                object-fit: cover;
                border-radius: 10px 0 0 10px;
            }
        }
        &__content{
            display: flex;
            flex-direction: column;
            padding: 30px 20px;
            flex: 0 0 67%;
            &__top{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                img{
                    transition: 0.3s ease;
                }
                p{
                    font-size: 14px;
                    line-height: 18px;
                    margin-bottom: 20px;
                    transition: 0.3s ease;
                    color: ${hover};
                }
                
            }
            h6{
                font-size: 18px;
                line-height: 24px;
                font-weight: 300;
                transition: 0.3s ease;
            }
        }
        &:hover{
            .news-list-item__content__top{
                img{
                    transform: rotate(45deg);
                }
                p{
                    color: ${hover};
                }
            }
            h6{
                color: ${hover};  
            }
        }
    }
    .news-list-first{
        display: flex;
        margin-bottom: 30px;
        background-color: #F9F9F9;
        position: relative;
        border-radius: 5px;
        a{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
        }
        &__left{
            flex: 0 0 40%;
            padding: 60px 40px 0 60px;
            p{
                font-size: 14px;
                line-height: 18px;
                color: #638297;
                margin-bottom: 20px;
            }
            h5{
                font-size: 24px;
                line-height: 32px;
                font-weight: 300;
                transition: 0.5s ease;

            }
        }
        &__right{
            flex: 0 0 60%;
            .img-wrapper{
                padding-top: calc(500 / 700 * 100%);
                position: relative;

                .thumb{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width:100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 0 10px 10px 0;
                } 
                .arrow{
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    transition: 0.5s ease;
                }
                @media(min-width: 1680px){
                    padding-top: calc(400 / 700 * 100%);
                }
            }
            
        }
        &:hover{
            h5{
                color: ${hover};
            }
            .arrow{
                transform: rotate(45deg);
            }
        }
        @media(max-width: 767px){
            flex-direction: column;
            &__left{
                flex: 0 0 100%;
                padding: 15px;
            }
            &__right{
                flex: 0 0 100%;
            }
        }
        
    }
    .col-md-6{
        margin-bottom: 30px;
    }
    .load-more{
        margin-top: 60px;
        .col{
            display: flex;
            justify-content: center;
        }
    }
    @media(max-width: 767px){
        br{
            display: none;
        }
    }
`;

export default MyComponent;
